import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

import { useSignUpStore } from "~/stores";
import { useFunnelStore } from "~/stores/useFunnelStore";
import { tw } from "~/utils";
import { isNonProduction } from "../../utils/envUtils";

interface FormActionButtonsContainerProps {
  children: ReactNode;
  className?: string;
  helperText?: string;
}

export const FormActionButtonsContainer = ({
  children,
  className,
  helperText,
}: FormActionButtonsContainerProps) => {
  const sessionId = useFunnelStore((s) => s.session_id);
  const groupName = useSignUpStore((s) => s.patient.groupName);

  // Session/group debug details are for staff only: show them on the
  // backoffice flow, never on the patient-facing /sign-up forms.
  const isBackofficeRoute = useLocation().pathname.startsWith("/backoffice");

  return (
    <div
      className={tw(
        // Mobile: fixed to bottom of screen with safe-area padding
        "fixed right-0 bottom-0 left-0 z-50 pb-[env(safe-area-inset-bottom)]",
        // Desktop: static, part of normal flow
        "sm:static sm:max-w-[570px] sm:rounded-b-lg sm:pb-0",
        // Styling
        "flex w-full flex-col bg-green-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] sm:shadow-none",
      )}
    >
      <div className={tw("flex w-full justify-end", className)}>{children}</div>
      {helperText && (
        <div className="px-4 pt-0 pb-3 text-center text-sm text-gray-600">
          {helperText}
        </div>
      )}
      {isBackofficeRoute && isNonProduction() && (sessionId || groupName) && (
        <div className="px-4 pb-2 text-center font-mono text-xs text-gray-400">
          {sessionId && <div>Session: {sessionId}</div>}
          {groupName && <div>Group: {groupName}</div>}
        </div>
      )}
    </div>
  );
};
